import styled from 'styled-components';

export const StyledMessage = styled.div`
  font-size: .9em;
  padding: 5px;
  background-color: #ffeb9c;
  color: #000;
  & i {
    float: right;
    padding: 3px;
  }
  & i:hover {
    cursor: pointer;
  }
`;

export default StyledMessage;
